import { render, staticRenderFns } from "./editFromGroup.vue?vue&type=template&id=188bd7b4"
import script from "./editFromGroup.vue?vue&type=script&lang=js"
export * from "./editFromGroup.vue?vue&type=script&lang=js"
import style0 from "./editFromGroup.vue?vue&type=style&index=0&id=188bd7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports